/* global apiCheck:false */
(function () {
    'use strict';

    angular
        .module('blocks.formly')
        .provider('formly', formlyProvider)
        .config(config)
        .constant('appApiCheck', apiCheck({
            output: { prefix: 'formlyExampleApp' }
        }));

    /**
     * Configure Formly
     */
    /* @ngInject */
    function formlyProvider() {
        /* jshint validthis:true */
        this.config = {

        };

        this.configure = function () {

        };

        this.$get = function () {
            return { config: this.config };
        };
    }

    /**
    * Configure Formly.
    * @param  {Object} $provide
    */
    /* @ngInject */
    function config(formlyConfigProvider) {
        formlyConfigProvider.setWrapper({
            name: 'loader',
            template: [
              '<label class="control-label">{{to.label}}</label>',
              '<formly-transclude></formly-transclude>',
              '<span class="fa fa-refresh error-loader" ng-show="to.loading"></span>'
            ].join(' ')
        });

        formlyConfigProvider.setType({
            name: 'input-loader',
            'extends': 'input',
            wrapper: ['loader']
        });

        formlyConfigProvider.setWrapper({
            template: '<formly-transclude></formly-transclude>' +
                '<div validation-message="options"></div>',
            types: ['input', 'checkbox', 'select', 'textarea', 'radio', 'input-loader']
        });
    }
})();
